import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Invisible Chairs',
		description:
			'Replace all chairs with invisible ones. Meetings become much more entertaining.'
	},
	{
		name: 'Upside Down Rooms',
		description: 'Install all furniture on the ceiling. Gravity is overrated.'
	},
	{
		name: 'Underwater Meetings',
		description:
			'Convert conference rooms into aquariums. SCUBA certification required.'
	},
	{
		name: 'Zero Gravity Chambers',
		description:
			'Host meetings in zero gravity. Floating laptops are now a common problem.'
	},
	{
		name: 'Time Dilation Suites',
		description: 'One-hour meetings now last several years for participants.'
	},
	{
		name: 'Quantum Conference Center',
		description:
			'Meetings occur in multiple dimensions simultaneously. Great for multitasking!'
	},
	{
		name: 'Void Meeting Rooms',
		description:
			'Hold meetings in the endless void. Perfect for existential discussions.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Luxury Conference Rooms'],
	departments[DepartmentIds['Luxury Conference Rooms']].basePrice * 3,
	UpgradeIds.LcrExponent1
)

export default array
